import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Tools from './pages/Tools';
import Videos from './pages/Videos';
import Stream from './pages/Stream';
import Reviews from './pages/Reviews';
import Streamers from './pages/Streamers';
import Contact from './pages/Contact';
import TrophyTracker from './pages/tools/TrophyTracker';
import AchievementTracker from './pages/tools/AchievementTracker';
import FollowTheMouse from './pages/tools/FollowTheMouse';
import GTA4Challenge from './pages/GTA4Challenge';
import GTA6Challenge from './pages/GTA6Challenge';
import ScrollToTop from './components/ScrollToTop';
import "./styles.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Tools />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/stream" element={<Stream />} />
        <Route path="/games" element={<Reviews />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/streamers" element={<Streamers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tools/trophy-tracker" element={<TrophyTracker />} />
        <Route path="/tools/achievement-tracker" element={<AchievementTracker />} />
        <Route path="/tools/follow-the-mouse" element={<FollowTheMouse />} />
        <Route path="/gta4-challenge" element={<GTA4Challenge />} />
        <Route path="/gta6-challenge" element={<GTA6Challenge />} />
      </Routes>
    </Router>
  );
}

export default App;
